export default "/Solway-Regular.a1e15992-612092.ttf";